import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import './main.scss'
import Home from './containers/home';
import WorkWithUs from './containers/work-with-us';
import Contact from './containers/contact';
import Certificates from './containers/certificates';
import AGuararapes from './containers/a-guararapes';
import Products from './containers/products';
import ProductsRoot from './containers/products-root';
import Product from './containers/product';
import Blog from './containers/blog';
import BlogIntern from './containers/blog-intern';
import Search from './containers/search';
import NotFound from './containers/not-found';
import OndeEncontrar from './containers/onde-encontrar';
import OndeEncontrarRepresentantes from './containers/onde-encontrar-representates';
import OndeEncontrarCompensados from './containers/onde-encontrar-compensados';

import LanguageContext from './context/LangContext';

const App = () => {
  const [language, setLanguage] = useState("pt-br");
  const value = { language, setLanguage };
  
  return (
    <LanguageContext.Provider value={value}>
      <div className="App">
        <Router onChange={() => window.scrollTo(0, 0)}>
          <Switch>
            <Route exact={ true } path="/" component={ Home } />
            <Route exact={ true } path="/contato/trabalhe-conosco" component={ WorkWithUs } />
            <Route exact={ true } path="/contato" component={ Contact } />
            <Route exact={ true } path="/certificados/:tipo" component={ Certificates } />
            <Route path="/certificados/:tipo/:section" component={ Certificates } />
            <Route exact={ true } path="/a-guararapes" component={ AGuararapes } />
            <Route path="/a-guararapes/:section" component={ AGuararapes } />
            <Route exact={ true } path="/produtos/mdf" component={ ProductsRoot } />
            <Route exact={ true } path="/produtos/mdf/:section" component={ ProductsRoot } />
            <Route exact={ true } path="/produtos/compensados" component={ ProductsRoot } />
            <Route exact={ true } path="/produtos/compensados/:section" component={ ProductsRoot } />
            <Route path="/produtos/:category/:type/:term" component={ Products } />
            <Route path="/produtos/:category" component={ Products } />
            <Route path="/produto/:uid" component={ Product } />
            <Route exact={ true } path="/conteudos" component={ Blog } />
            <Route path="/conteudos/:category" component={ Blog } />
            <Route exact={ true } path="/conteudo/:uid" component={ BlogIntern } />
            <Route path="/busca/:search" component={ Search } />
            <Route exact={ true } path="/onde-encontrar/compensados" component={ OndeEncontrarCompensados } />
            <Route exact={ true } path="/onde-encontrar/representantes" component={ OndeEncontrarRepresentantes } />
            <Route exact={ true } path="/onde-encontrar" component={ OndeEncontrar } />
            <Route path="*" component={ NotFound } status={404}/>
          </Switch>
        </Router>
      </div>
    </LanguageContext.Provider>
  );
}

export default App;
